import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";
import { AddressDto, ApartmentDto } from "@/api/models/coverage.model";

interface ProductChangeOfAddressState {
	id: number;
	status: string;
	changeOfAddress2ndPhase: {
		coverage: {
			search: string;
			searchType: string;
		};
		address: {
			id: string;
			address: string;
			salesArea: string;
			status: string;
			lat: string;
			lng: string;
		};
		apartment: ApartmentDto;
		notes: string;
		salesPerson: string;
		targetDate: string;
		intermediateProduct: {
			salesPerson: string;
			targetDate: string;
		};
	};
	shoppingCartId?: string;
}

export const productChangeOfAddressInitialState = (): ProductChangeOfAddressState => {
	return {
		id: -1,
		status: "",
		changeOfAddress2ndPhase: {
			coverage: {
				search: "",
				searchType: ""
			},
			address: {
				id: "-1",
				address: "",
				salesArea: "",
				status: "",
				lat: "",
				lng: ""
			} as AddressDto,
			apartment: {
				apartmentId: "-1",
				floor: "",
				door: "",
				stair: "",
				network: ""
			} as ApartmentDto,
			notes: "",
			salesPerson: "",
			targetDate: "",
			intermediateProduct: {
				salesPerson: "",
				targetDate: ""
			}
		},
		shoppingCartId: undefined
	};
};

const state: ProductChangeOfAddressState = productChangeOfAddressInitialState();

export default {
	state,
	actions,
	mutations,
	getters
};
